import React from 'react';

const RatColumns = () => (
  <tr>
    <th>Actions</th>
    <th>Numéro</th>
    <th>Produit</th>
    <th>Manip. Produit</th>
    <th>
      Matériel
      <br />
      Complémentaire
    </th>
    <th>
      Manip. Matériel
      <br />
      Complémentaire
    </th>
    <th>Conso. (%)</th>
    <th>Capture</th>
  </tr>
);

export default RatColumns;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/components/types/RatColumns.js